import { createContext, useEffect, useState } from 'react';
import { TeamsUserCredential, UserInfo } from '@microsoft/teamsfx';

import { rootStoreInstance } from 'src/stores/RootStore';
import config from 'src/configs/config';

export interface TeamsUserContextType {
  user: UserInfo | null
  loading: boolean
}

export const TeamsUserContext = createContext<TeamsUserContextType | undefined>(undefined);

export const TeamsUserProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<UserInfo | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const credential = new TeamsUserCredential({
          initiateLoginEndpoint: config.initiateLoginEndpoint!,
          clientId: config.clientId!,
        });
        const userInfo = await credential.getUserInfo();
        setUser(userInfo);
        rootStoreInstance.teamsUserStore.setUser(userInfo);
      }
      // eslint-disable-next-line no-useless-catch
      catch (error) {
        throw error;
      }
      finally {
        setLoading(false);
      }
    };

    fetchUserInfo();
  }, []);

  return <TeamsUserContext.Provider value={{ user, loading }}>{children}</TeamsUserContext.Provider>;
};
